import { Typography, Grid, Container, Paper, styled, Button, Rating, TextField, List, ListItem, Tooltip, IconButton } from "@mui/material";
import React, { useState, useEffect } from "react";
import globals from "../globals";
import { borderColor, display, fontSize, Stack } from "@mui/system";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import DoneIcon from '@mui/icons-material/Done';
import CourseCarousel from "../components/carousels/courseCarousel";
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import GroupsIcon from '@mui/icons-material/Groups';
import { useParams, useNavigate } from "react-router-dom";
import NotFound from "../error-page";
import { useAuth } from "../context/AuthContext";
import LoadingIcon from "../components/loading";
import { useCart } from "../context/CartContext";
import BlueButton from "../components/blueButton";
import RedButton from "../components/redButton";
import { formatEur, formatLevaTooltip } from "../utils";
import InfoIcon from '@mui/icons-material/Info';

const CoursePage = ({ course, showPublish }) => {
    const { id } = useParams();
    const { token } = useAuth();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const { addToCart } = useCart();

    //console.log(course, 'course');
    const [courseSaved, setCourseSaved] = useState(course.saved);

    const handleSave = () => {
        setCourseSaved(!courseSaved);
        fetch(globals.apiUrl + `/courses/student/saved/${id}`, {
            method: courseSaved ? 'DELETE' : 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        })
            .then(response => response.json())
            .then(data => {
                //console.log(data);
                // setCourseSaved(data.success);
            })
            .catch(error => {
                console.error('Error:', error);
            });
    }

    const [question, setQuestion] = useState('');

    const handleQuestionChange = (event) => {
        setQuestion(event.target.value);
    }

    const handleSendQuestion = (event) => {
        if (!token) {
            navigate('/login');
        }
        if (question.trim().length > 0) {
            setLoading(true);
            event.target.disabled = true;

            fetch(globals.apiUrl + `/courses/chats/student/${id}`, {
                method: 'POST',
                body: JSON.stringify({ message: question }),
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(data => {
                    //console.log(data);
                    setSuccess(true);
                })
                .catch(error => {
                    console.error('Error:', error);
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    }


    const Item = styled(Paper)(({ theme }) => ({
        ...theme.typography.body2,
        padding: theme.spacing(3),
        textAlign: 'left',
        color: globals.colors.textColor,
        ...theme.applyStyles('dark', {
            backgroundColor: globals.colors.textColor,
        }),
    }));

    const MoreInfoButton = styled(Button)(() => ({
        color: globals.colors.backgroundColor,
        backgroundColor: globals.colors.lightRed,
        '&:hover': {
            backgroundColor: globals.colors.darkRed,
            color: globals.colors.backgroundColor,
        },
        '&.Mui-selected': {
            color: globals.colors.lightRed,
        },
    }))

    const CartButton = styled(Button)(() => (
        {
            backgroundColor: globals.colors.lightRed,
            '&:hover': {
                backgroundColor: globals.colors.darkRed,
                color: globals.colors.backgroundColor,
            },
            '&.Mui-selected': {
                color: globals.colors.darkRed,
            },
        }
    ))


    const SendQuestionButton = styled(Button)(() => ({
        color: globals.colors.backgroundColor,
        backgroundColor: globals.colors.darkBlue,
        '&:hover': {
            backgroundColor: globals.colors.lightBlue,
            color: globals.colors.backgroundColor,
        },
        '&.Mui-selected': {
            color: globals.colors.lightRed,
        },
    }))


    const FavButton = styled(Button)(() => (
        {
            backgroundColor: 'transparent',
            color: globals.colors.textColor,
            borderColor: globals.colors.textColor,
            '&:hover': {
                backgroundColor: globals.colors.backgroundColor,
                color: globals.colors.textColor,
                borderColor: globals.colors.textColor
            },
            '&.Mui-selected': {
                color: globals.colors.darkRed,
            },
        }
    ))

    const handlePublishCourse = () => {
        fetch(globals.apiUrl + `/courses/${id}/publish`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        });
    }


    return (
        <Container>
            {
                showPublish && (
                    <>
                        <RedButton onClick={() => handlePublishCourse()} text={"Одобри и публикувай курс"} pX={4}/>
                        <LoadingIcon />
                    </>
                )
            }
            <Grid container sx={{ justifyContent: 'center', mt: 0.5 }} spacing={5}>
                <Grid item xs={12} sm={8} maxWidth={650}>
                    <Typography sx={{ color: globals.colors.lightRed, fontSize: 40 }} ><strong>{course.title}</strong></Typography>
                    <Grid container sx={{ mt: -2 }} justifyContent={'left'} spacing={5}>
                        <Grid item xs={12} sm={5}>
                            <Grid container >
                                <Typography variant="body2" sx={{ pt: 0.5, color: globals.colors.gray }}><strong> Категория: </strong></Typography>
                                <Typography variant="body2" sx={{ pt: 0.5, ml: 1 }}><strong> {course.category.join(", ")} </strong></Typography>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} sm={7}>
                            <Grid container>
                                <AccessTimeIcon sx={{ fontSize: 20, mt: 0.5 }} />
                                <Typography variant="body2" sx={{ pt: 0.5, color: globals.colors.gray, ml: 1 }}><strong>Продължителност на един урок:</strong></Typography>
                                <Typography variant="body2" sx={{ pt: 0.5, ml: 1 }}><strong>{course.duration} минути</strong></Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Typography variant="body1" color={globals.colors.textColor} sx={{ mt: 5 }} dangerouslySetInnerHTML={{ __html: course.description }}></Typography>

                    <Grid container sx={{ mt: 5 }} direction={'column'}>
                        <Grid item>
                            <Typography sx={{ fontWeight: 'bold', fontSize: 23, color: globals.colors.lightRed }}>Подходящ за:</Typography>
                        </Grid>
                        <Grid container spacing={4} sx={{ pt: 3 }}>
                            {course.good_for.map(
                                level =>
                                    <Grid item>
                                        <Paper sx={{ px: 2, py: 1, backgroundColor: globals.colors.darkBlue }}>
                                            <Typography sx={{ color: globals.colors.backgroundColor, fontWeight: 'bold' }}>{level}</Typography>
                                        </Paper>
                                    </Grid>
                            )}
                        </Grid>
                    </Grid>

                    <Grid container sx={{ mt: 3 }}>
                        <Typography variant="h6" color={globals.colors.lightRed} sx={{ mt: 4, fontSize: 23 }}><strong>Примерни теми по време на обучението:</strong></Typography>
                        <Grid container>
                            {course.example_topics.map((courseTheme, i) => {
                                return (
                                    <Grid item sm={6} xs={12} sx={{ pt: 2 }}>
                                        <DoneIcon sx={{ mb: -1, mr: 1, color: globals.colors.lightRed }} /><strong>Тема {i + 1}.</strong> {courseTheme}
                                    </Grid>
                                )
                            })}
                        </Grid>

                    </Grid>

                    <Grid justifyContent={'start'} alignItems={'start'}>
                        <Typography sx={{ mt: 7, color: globals.colors.lightRed, fontSize: 23, mb: 4 }}><strong>Кой ще ти преподава?</strong></Typography>
                        <Grid container justifyContent={'start'}>
                            <Grid item xs={12} sm={4} sx={{ mr: 2 }}>
                                <img src={(course.instructor_image_url) ? course.instructor_image_url : '/noone.webp'} height={250} width={250} style={{ borderRadius: 10 }} />
                            </Grid>
                            <Grid item xs={12} sm={4} maxWidth={450}>
                                <Typography variant="h6" sx={{ color: globals.colors.darkRed }}><strong>{course.instructor_name}</strong></Typography>
                                <Typography variant="body1" color={globals.colors.textColor} sx={{ mt: 1, mb: 2 }} dangerouslySetInnerHTML={{ __html: course.instructor_description?.slice(0, Math.min(200, course.instructor_description.length)).concat('...') }}></Typography>
                                <MoreInfoButton onClick={() => navigate(`/instructor/${course.instructor_id}`)} sx={{ textTransform: 'none', fontWeight: 'bold' }}>Научи повече за {course.instructor_name.trim().split(' ')[0]} тук</MoreInfoButton>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>


                <Grid item xs={12} sm={4}>
                    <Grid container justifyContent={'center'} alignItems={'center'} textAlign={'center'} direction={'column'} spacing={3}>
                        <Grid item>
                            <img src={course.image_url} height={200} width={350} />
                        </Grid>
                        <Grid item>
                                <Typography variant="h5" textAlign={'center'}><strong>{course.duration} мин. / {formatEur(course.price)}</strong>
                            <Tooltip title={formatLevaTooltip(course.price)}>
                            <IconButton>
                                    <InfoIcon fontSize="small" />
                                </IconButton>
                            </Tooltip>
                            </Typography>
                        </Grid>
                        <Grid item>
                            <CartButton disabled={course.enrolled_students_count >= course.capacity} variant="contained" size='large' onClick={() => { addToCart(course); navigate(`/choose/${id}`) }} sx={{ textTransform: 'none', fontSize: 17, width: 320 }}><ShoppingCartIcon sx={{ mr: 1 }} /><strong>{course.enrolled_students_count >= course.capacity ? 'Курсът е запълнен' : 'Добавяне в количка'}</strong></CartButton>
                        </Grid>
                        <Grid item>
                            <CartButton variant="contained" size='large' href={`/request/${id}`} sx={{ width: 320, textTransform: 'none', fontSize: 17, backgroundColor: globals.colors.darkBlue, '&:hover': { backgroundColor: globals.colors.lightBlue } }}><GroupsIcon sx={{ mr: 1 }} /><strong>Заяви опознавателна среща</strong></CartButton>
                        </Grid>
                        <Grid item>
                            <FavButton sx={{ textTransform: 'none', fontSize: 17, color: globals.colors.darkBlue, fontWeight: 'bold' }} onClick={handleSave}>Запази курс {(courseSaved) ? <BookmarkIcon sx={{ color: globals.colors.darkBlue, ml: 1 }} /> : <BookmarkBorderIcon sx={{ color: globals.colors.darkBlue, ml: 1 }} />} </FavButton>
                        </Grid>
                    </Grid>

                    <Grid container justifyContent={'left'} textAlign={'left'}>
                        <Grid item>
                            <Typography sx={{ mt: 6, color: globals.colors.lightRed, fontSize: 23, mb: 1 }}><strong>Включени материали:</strong></Typography>
                            <List sx={{ listStyleType: 'disc' }}>
                                {course.included_materials.map((material) => (
                                    <ListItem sx={{ display: 'list-item' }}>{material}</ListItem>
                                )
                                )}
                            </List>
                        </Grid>
                        <Grid item>
                            <Typography sx={{ mt: 6, color: globals.colors.lightRed, fontSize: 23, mb: 1 }}><strong>Изисквания:</strong></Typography>
                            <List sx={{ listStyleType: 'disc' }}>
                                {course.student_requirements.map((requirement) => (
                                    <ListItem sx={{ display: 'list-item' }}>{requirement}</ListItem>
                                )
                                )}
                            </List>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>


            {((course.showChat && !success) || !token) && (
                <Grid container sx={{ mt: 7 }}>
                    <Grid item xs={12} sm={12}>
                        <Typography sx={{ color: globals.colors.lightRed, fontSize: 23, fontWeight: 'bold' }}>Задай въпрос към учителя</Typography>
                        <TextField
                            id="outlined-multiline-static"
                            multiline
                            rows={5}
                            fullWidth
                            value={question}
                            onChange={handleQuestionChange}
                            sx={{
                                borderRadius: 1,
                                color: globals.colors.textColor,
                                '& .MuiOutlinedInput-root': {
                                    '& fieldset': {
                                        borderColor: globals.colors.darkRed, // default border color
                                    },
                                    '&:hover fieldset': {
                                        borderColor: globals.colors.darkRed, // border color on hover
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: globals.colors.darkRed, // border color when focused
                                    },
                                },
                            }}
                        />
                    </Grid>
                    <Grid container textAlign={'end'} justifyContent={'end'} fullWidth sx={{mt:2}}>
                        <Grid item>
                            {loading && <LoadingIcon sx={{ mt: 1, mr: 2 }} />}
                            <SendQuestionButton onClick={handleSendQuestion} sx={{ textTransform: 'capitalize', fontSize: 15, fontWeight: 'bold' }}>Изпрати</SendQuestionButton>
                        </Grid>
                    </Grid>

                </Grid>
            )}
            {success && (
                <Grid container sx={{ mt: 7 }} justifyContent={'center'}>
                    <Grid item xs={12} sm={12}>
                        <Typography sx={{ color: globals.colors.darkBlue, fontSize: 20, fontWeight: 'bold' }}>Въпросът е изпратен успешно!</Typography>
                    </Grid>
                </Grid>
            )}

            {/* <Grid container justifyContent={'center'} sx={{ mt: 10 }}>
                <Grid item>
                    <Typography sx={{ color: globals.colors.lightRed, fontSize: 40, mb: 2 }}><strong>Често купувани заедно</strong></Typography>
                </Grid>
                <Grid item>
                    <CourseCarousel courses={[]} />
                </Grid>
            </Grid> */}
        </Container>
    );
}

export default CoursePage